import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class OptionSearchUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(data) {
        return await this.Repo.getOpSearch(data);
    }
}
export default OptionSearchUseCase;
